import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';

import { AppReady, SetApiEnv } from './app.actions';
import { ApiEnv, AwareHttpService } from '@appbolaget/aware-http';
import { environment } from '@env';
import { environment as envDev } from '../../environments/environment.dev';
import { environment as envProd } from '../../environments/environment.prod';

export interface AppStateModel {
    state_init: boolean;
    app_init: boolean;
    api_env?: ApiEnv;
}

@State<AppStateModel>({
    name: 'app',
    defaults: {
        state_init: false,
        app_init: false,
        api_env: {
            name: environment.envName,
            url: environment.api.url,
            unit: environment.api.unit,
        },
    },
})
@Injectable({ providedIn: 'root' })
export class AppState {
    @Selector()
    static apiEnv({ api_env }: AppStateModel): ApiEnv {
        return api_env;
    }

    @Selector()
    static availableEnvs(): ApiEnv[] {
        const envs = [envDev, envProd];
        return envs.map((env) => ({ name: env.envName, url: env.api.url, unit: env.api.unit }));
    }

    constructor(private api: AwareHttpService) {}

    ngxsOnInit({ patchState }: StateContext<AppStateModel>) {
        patchState({
            state_init: true,
        });
    }

    @Action(AppReady)
    appReady({ patchState }: StateContext<AppStateModel>) {
        patchState({
            app_init: true,
        });
    }

    @Action(SetApiEnv)
    setApiEnv({ patchState }: StateContext<AppStateModel>, { env }: SetApiEnv) {
        patchState({
            api_env: env,
        });

        this.api.setApiEnv(env);
    }
}
